import {
  VoiceService
} from './voice.service';

export const VoiceInjectables: Array<any> = [
  {provide: VoiceService, useClass: VoiceService},
];
